import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=183527a9&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=183527a9&prod&scoped=true&lang=css"
import style1 from "./UserDetails.vue?vue&type=style&index=1&id=183527a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183527a9",
  null
  
)

export default component.exports